var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPsCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#F1ECFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_367_3287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6666 14V12.6667C24.6666 12.4899 24.5964 12.3203 24.4714 12.1953C24.3464 12.0702 24.1768 12 24 12C23.8232 12 23.6536 12.0702 23.5286 12.1953C23.4036 12.3203 23.3333 12.4899 23.3333 12.6667V14H24.6666Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 14V12.6667C16.6666 12.4899 16.5964 12.3203 16.4714 12.1953C16.3464 12.0702 16.1768 12 16 12C15.8232 12 15.6536 12.0702 15.5286 12.1953C15.4036 12.3203 15.3333 12.4899 15.3333 12.6667V14H16.6666Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 27.3334H14C13.4696 27.3334 12.9609 27.1226 12.5858 26.7476C12.2107 26.3725 12 25.8638 12 25.3334V16.6667C12 16.1363 12.2107 15.6275 12.5858 15.2525C12.9609 14.8774 13.4696 14.6667 14 14.6667H26C26.5304 14.6667 27.0391 14.8774 27.4142 15.2525C27.7893 15.6275 28 16.1363 28 16.6667V25.3334C28 25.8638 27.7893 26.3725 27.4142 26.7476C27.0391 27.1226 26.5304 27.3334 26 27.3334ZM26.6667 18H13.3333V25.3334C13.3333 25.5102 13.4036 25.6797 13.5286 25.8048C13.6536 25.9298 13.8232 26 14 26H26C26.1768 26 26.3464 25.9298 26.4714 25.8048C26.5964 25.6797 26.6667 25.5102 26.6667 25.3334V18Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 19.3333H14.6667V21.3333H17.3334V19.3333Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 19.3333H18.6667V21.3333H21.3334V19.3333Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 22.6667H14.6667V24.6667H17.3334V22.6667Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 22.6667H18.6667V24.6667H21.3334V22.6667Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 19.3333H22.6667V21.3333H25.3334V19.3333Z",
    fill: "#9C82FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_3287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsCalendar);
export default __webpack_public_path__ + "static/media/ps-calendar.0e605c1b123642729707f2c419175690.svg";
export { ForwardRef as ReactComponent };